import { useEffect } from "react";
import axios from "axios";

/** Écran public ouvert avec ?ecran={id} (registre des écrans du Centre de contrôle) → ping toutes les 30 s. Sans paramètre : aucun appel. */
export function useScreenPing() {
  useEffect(() => {
    const id = new URLSearchParams(window.location.search).get("ecran");
    if (!id) return undefined;
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/jm/public/screen-ping/${id}`;
    const ping = () => axios.post(url).catch(() => {});
    ping();
    const t = setInterval(ping, 30000);
    return () => clearInterval(t);
  }, []);
}
